/* eslint-disable react/jsx-props-no-spreading */
import { useRoutes, useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRoute } from 'wouter';

import useOpenedState from '../../../hooks/useOpenedState';
import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Button from '../../buttons/Button';
import ChevronIcon from '../../icons/Chevron';
import SparklesIcon from '../../icons/Sparkles';
import HeaderDefault from '../../partials/HeaderDefault';
import OtherLocales from '../../partials/OtherLocales';

import styles from '../../../../styles/themes/iga/header-iga-noel.module.scss';

const propTypes = {
    className: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    footerMenuItems: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    pageUrls: null,
    footerMenuItems: null,
};

function HeaderIGANoel({ className, pageUrls, footerMenuItems, ...props }) {
    const url = useUrlGenerator();
    const themeClassName = useThemeClassName(styles);
    const openedState = useOpenedState();

    const { menuOpened = false } = openedState || {};

    const routes = useRoutes();

    const [matchGame] = useRoute(routes.game);
    const [matchParticipation] = useRoute(routes.participation);

    const isGame = matchGame || matchParticipation;

    return (
        <HeaderDefault
            className={classNames([styles.container, themeClassName, className])}
            fixedBackgroundClassName={styles.fixedBackground}
            fixedContentClassName={styles.fixedContent}
            logoButtonClassName={styles.logoButton}
            logoClassName={styles.logo}
            menuClassName={styles.menu}
            itemClassName={styles.menuItem}
            toggleContentClassName={styles.toggleContent}
            togglerClassName={styles.toggler}
            itemActiveClassName={styles.itemActive}
            withoutOtherLocales
            openedState={openedState}
            menuChildren={
                <>
                    <SparklesIcon className={classNames([styles.sparkles, styles.sparkles1])} />
                    <SparklesIcon className={classNames([styles.sparkles, styles.sparkles2])} />
                    <div className={styles.content}>
                        <OtherLocales
                            className={styles.otherLocales}
                            linkClassName={styles.otherLocale}
                            pageUrls={pageUrls}
                        />
                    </div>
                </>
            }
            {...props}
        >
            {isGame && !menuOpened ? (
                <div className={styles.buttonContainer}>
                    <Button
                        href={url('play')}
                        external={false}
                        direct={false}
                        className={styles.calendarButton}
                    >
                        <ChevronIcon className={styles.chevron} />
                        <FormattedMessage
                            defaultMessage="Mini-Game calendar"
                            description="Link label"
                        />
                    </Button>
                </div>
            ) : null}
        </HeaderDefault>
    );
}

HeaderIGANoel.propTypes = propTypes;
HeaderIGANoel.defaultProps = defaultProps;

export default HeaderIGANoel;
